// DHL rejects the sender address company above this length (SM-2442).
//
// The sender address is the only part of the payload return-service forwards to
// tracking-service, so exactly the values that land on it are capped: the
// off-portal companyName becomes sender_address.company and takes this limit.
// The two fields that become sender_address.name - the off-portal senderName
// and the portal modal fullName - have their own, looser ceiling, see
// RETURN_LABEL_SENDER_NAME_MAX_LENGTH below.
//
// The off-portal contactName is deliberately not capped with this - it stays on
// the request as the requester's notification name and never reaches DHL.
//
// Characters, not bytes - "TUEV SUED" style umlauts make the two diverge, and
// the SM-2442 repro accepted a 34-character / 36-byte value while rejecting a
// 41-character one, which rules out a byte limit.
//
// TODO(SM-2442): the 35 comes from the reported repro, not from a spec - the DHL
// adapter lives in tracking-service and encodes no limit we can read. Reconcile
// against the authoritative per-carrier table once published; DHL Paket DE may
// allow more than DHL Express, in which case this is the stricter of the two.
export const RETURN_LABEL_NAME_MAX_LENGTH = 35

// The ceiling for the two fields that become sender_address.name on the carrier
// payload - the name DHL prints on the label: the off-portal senderName and the
// portal modal fullName. Product asked for 50 here rather than the 35 above so
// that a person plus a department or a c/o line still fits (SM-2442).
export const RETURN_LABEL_SENDER_NAME_MAX_LENGTH = 50
